// ---------------------------------------------------------------------------
// User Permissions API client — Round 19 (2026).
// Wraps /api/admin/user-permissions/* so the page doesn't have to know the
// URL shape or pluck .data from every response.
// All endpoints require IT Admin (the controller has [Authorize(Roles=...)]).
// ---------------------------------------------------------------------------
import api from "../api";

/** All permissions defined in SSW_Dashboard_Permissions. */
export const fetchPermissionCatalog = async () => {
    const res = await api.get("/admin/user-permissions/catalog");
    return Array.isArray(res.data) ? res.data : [];
};

/** List of employees for the user-picker. */
export const fetchEmployees = async () => {
    const res = await api.get("/admin/user-permissions/employees");
    return Array.isArray(res.data) ? res.data : [];
};

/** Effective permissions for one employee, tagged by source.
 *  Returns null if the employee can't be found. */
export const fetchUserPermissions = async (empId) => {
    try {
        const res = await api.get(`/admin/user-permissions/${encodeURIComponent(empId)}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 404) return null;
        throw err;
    }
};

/** Grant a permission directly to a user. Returns the fresh snapshot. */
export const grantPermission = async (empId, permissionName) => {
    const res = await api.post(
        `/admin/user-permissions/${encodeURIComponent(empId)}`,
        { permissionName }
    );
    return res.data;
};

/** Revoke a DIRECT-source permission. Returns the fresh snapshot. */
export const revokePermission = async (empId, permissionName) => {
    const res = await api.delete(
        `/admin/user-permissions/${encodeURIComponent(empId)}/${encodeURIComponent(permissionName)}`
    );
    return res.data;
};
